import React, { useState, useEffect } from 'react';

const ButtonBaseOutline = ({ borderStyle = 'dashed', ...props }) => {
    const [bClass, setBClass] = useState('');
    
    useEffect(() => {
        const validBorderStyles = ['dashed', 'solid'];
        
        if (validBorderStyles.includes(borderStyle)) {
            setBClass('border-' + borderStyle);
        }
    }, [borderStyle]);

    return (
        <button type='button'
            className={`bg-white text-lavender border border-lavender rounded-2xl px-4 min-h-[42px] text-base text-medium ${bClass} ${props.className || ''}`}
        >
            {props.children}
        </button>
    );
};

export default ButtonBaseOutline;
